import { unwrapResult } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { getUnusedBeamPhotos } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';

const CleanUp = () => {
  const dispatch = useAppDispatch();

  const [photos, setPhotos] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const res: any = await unwrapResult(
        await dispatch(getUnusedBeamPhotos()),
      );
      if (res.photos?.length) {
        setPhotos(res.photos);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="content">
      {photos.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4">
          {photos.map((item, index) => (
            <img
              key={index}
              src={item.medium}
              alt={`img-${index}`}
              className="w-full h-40 object-cover rounded-lg shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CleanUp;
